import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'
import { Mixpanel } from '@/analytics/mixpanel'

/**
 * Handle show more / less links in HtmlText component for static pages.
 */
function initializeHtmlTextHandler(): void {
  const textComponents = document.querySelectorAll('.sf-html-text')
  for (let i = 0; i < textComponents.length; i++) {
    const textComponent = textComponents[i]

    const shortBlock = textComponent.querySelector(
      '.sf-html-text__short',
    ) as HTMLElement | null

    const fullBlock = textComponent.querySelector(
      '.sf-html-text__full',
    ) as HTMLElement | null

    if (!shortBlock || !fullBlock) {
      continue
    }

    const shortBlockA = shortBlock.querySelector('.sf-html-text-switch')
    if (shortBlockA) {
      shortBlockA.addEventListener('click', function () {
        shortBlock.style.display = 'none'
        fullBlock.style.display = 'inline'
      })
    }

    const fullBlockA = fullBlock.querySelector('.sf-html-text-switch')
    if (fullBlockA) {
      fullBlockA.addEventListener('click', function () {
        shortBlock.style.display = 'inline'
        fullBlock.style.display = 'none'
      })
    }
  }
}

export function initPageBestBooks(): void {
  initMixpanel()
  sentryInit()

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(() => {
      initializeHtmlTextHandler()
      Mixpanel.pageView()
    }, 1500)
  })
}
